module.exports = __webpack_public_path__ + "img/august_600.6d224be9.png";